// frontend/src/pages/storeActivity/EmailsPanel.jsx
//
// Every email filed against this store (backend core.models.EmailLog): the
// mail its people got, and the team mail about them. The recipients say
// which is which; the raw kind stays under the subject because it is what
// the log lines and the Django admin call the same send.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ICON, EnvelopeSimple } from '../../icons';
import { Panel, RelativeTime } from './primitives';

export default function EmailsPanel({ emails, truncated }) {
  const { t } = useTranslation();
  return (
    <Panel
      icon={<EnvelopeSimple size={ICON.md} />}
      title={t('storeActivity.emails.title')}
      subtitle={t('storeActivity.emails.subtitle')}
      count={emails.length}
    >
      {emails.length === 0
        ? <div className="sa-panel-empty">{t('storeActivity.emails.empty')}</div>
        : (
          <div className="sa-list">
            {emails.map((email, i) => (
              <div className="sa-list-row" key={i}>
                <div className="sa-list-main">
                  <div className="sa-list-primary sa-list-primary--wrap">{email.subject}</div>
                  <div className="sa-list-secondary">
                    {`${t('storeActivity.emails.to')} ${email.recipients.join(', ')} · `}
                    <code className="sa-code">{email.kind}</code>
                  </div>
                </div>
                <RelativeTime className="sa-list-secondary" value={email.sent_at} />
              </div>
            ))}
          </div>
        )}
      {truncated && (
        <div className="sa-panel-note">{t('storeActivity.truncated.emails')}</div>
      )}
    </Panel>
  );
}
